import React, { useEffect, useState } from "react";
import styles from "./Table.module.css";
import Pagination from "rc-pagination";
import Button from "../Forms/Button";
import {
    MdOutlineDelete,
    MdOutlineFileDownload,
    MdOutlineEditNote,
    MdSearch,
    MdOutlinePushPin,
    MdOutlineFileOpen,
    MdDriveFileRenameOutline,
    MdOutlineSubtitlesOff,
    MdKeyboardArrowDown
} from "react-icons/md";
import services from "../../Services/services";
import { fetchDeleteFile } from "../../Services/Slices/deleteFileSlice";
import {useDispatch, useSelector} from "react-redux";
import Loading from "../Loading/Loading";
import { fetchDeletePublishedFile } from "../../Services/Slices/deletePublishedFileSlice";
import { returnHandleExtractUrl, formatFileName } from "../Helper";
import { useNavigate } from "react-router-dom";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Autocomplete,
    TextField,
} from "@mui/material";
import { fetchListPosts } from "../../Services/Slices/listPostsSlice";
import {updatePost} from "../../Services/Slices/postSlice";
import { patchFavoritePost } from "../../Services/Slices/patchFavoritePost";
import {isLoggedIn} from "../../Auth/auth";
import { patchPostDescription } from "../../Services/Slices/updatePostDescriptionSlice";
import { fetchFavoritePosts } from "../../Services/Slices/favoritePostsSlice";
import { PATH } from "../../PATH";

interface TableProps {
    title?: string;
    columns: any;
    data: any;
    setPage: any;
    page: any;
    downloadButton?: boolean;
    total?: number;
    isEmpty?: boolean;
    isStatus?: boolean;
    loading?: boolean;
    error?: boolean;
    onToggleReverse?: () => void;
    isSearched?: boolean
}

type File = { file_name: string, id: string; checked: boolean };

const Table: React.FC<TableProps> = ({
                                         title,
                                         columns,
                                         data,
                                         setPage,
                                         page,
                                         downloadButton,
                                         total,
                                         isEmpty,
                                         isStatus,
                                         loading,
                                         error,
                                         onToggleReverse,
                                         isSearched
                                     }) => {
    const [currentPage] = useState<number>(1);
    const [isResponsive, setIsResponsive] = useState(false);
    const [deletingId, setDeletingId] = useState<string | null>(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [fileKeyToRevoke, setFileKeyToRevoke] = useState<string | null>(null);
    const [selectedFiles, setSelectedFiles] = useState<string[]>([]);
    const [openSecondDialog, setOpenSecondDialog] = useState(false);
    const dispatch = useDispatch<any>();
    const navigate = useNavigate();
    const [fileKeyName, setFileKeyName] = useState<string | null>(null);
    const [openDialogDescription, setOpenDialogDescription] = useState(false);
    const [description, setDescription] = useState("")
    const [fileName, setFileName] = useState("");
    const [caracterLimit, setCaracterLimit] = useState(false);
    const [message, setMessage] = useState("")
    const favoritePosts = useSelector((state: any) => state.favoritePostsSlice.data);
    const [posts, setPosts] = useState<any[]>([]);
    const [openDialogDelete, setOpenDialogDelete] = useState(false);
    const [deleteRow, setDeleteRow] = useState<any>()
    const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');

    const listPosts = useSelector((state: any) => state.listPostsSlice);

    useEffect(() => {
        if (isLoggedIn()) {
            dispatch(fetchListPosts("1", true));
            dispatch(fetchFavoritePosts());
        }
    }, [dispatch]);

    useEffect(() => {
        if (favoritePosts?.favorite_posts) {
            setPosts(favoritePosts.favorite_posts);
        }
    }, [favoritePosts]);

    useEffect(() => {
        if (isSearched) {
            setSortDirection('asc')
        }
    }, [isSearched]);

    const handleDeletePublishedFileDialog = (row:any) =>{
        setOpenDialogDelete(true)
        setDeleteRow(row);
    };

    const handleDialogDeleteClose = () => {
        setOpenDialogDelete(false);
    };

    const handleSortClick = () => {
        setSortDirection(prev => (prev === 'asc' ? 'desc' : 'asc'));
        if (onToggleReverse) {
            onToggleReverse()
        }
    };

    const handleDeletePublishedFile = () => {
        const extractedUrl = returnHandleExtractUrl(deleteRow.presigned_url);
        setDeletingId(deleteRow.edition);

        dispatch(fetchDeletePublishedFile(extractedUrl ? extractedUrl : ""))
            .finally(() => {
                setDeletingId(null);
                dispatch(fetchFavoritePosts());
                handleDialogDeleteClose();
            });
    };

    const handleDownloadFile = (file: string) => {
        const a = document.createElement("a");
        a.href = file;
        a.download = "downloadedFile.html";
        a.click();
    };

    const handleDownloadTemplate = async () => {
        const file_name = "ATOS Modelo.docx";
        const file = await services.downloadFiles(file_name);
        const a = document.createElement("a");
        a.href = file?.data?.url;
        a.download = "template.html";
        a.click();
    };

    const handleFavoritePost = async () => {
        await dispatch(patchFavoritePost(fileName));
        await dispatch(patchPostDescription(fileName, description));
        dispatch(fetchFavoritePosts());
    };    
    
    function handleRevokeEdition(fileKey: string) {
        setFileKeyToRevoke(fileKey);
        setFileKeyName(cleanFile(fileKey));
        setOpenDialog(true);
    }

    function handleCreateDialogDescription(){
        setOpenDialogDescription(true);
        setDescription("")
        setMessage("")
    }

    const handleDialogDescriptionClose = () => {
        setOpenDialogDescription(false);
    };

    const handleSubmitDescription = () =>{
        if (description.length > 0 && description.length <= 200){
            setCaracterLimit(false)
            setOpenDialogDescription(false);
            handleFavoritePost();
        }
        else if (description.length > 200){
            setCaracterLimit(true)
            setMessage("Descrição maior que 200 caracteres")
        }
        else{
            setCaracterLimit(true)
            setMessage("Adicione uma descrição")
        }
    };

    const handleDialogClose = () => {
        setOpenDialog(false);
        setFileKeyToRevoke(null);
    };

    const handlePartialRevoke = () => {
        if (fileKeyToRevoke) {
            navigate(`/revogar-ato/${cleanFile(fileKeyToRevoke)}`);
        }
        setOpenDialog(false);
    };

    const handleInclude = () => {
        if (fileKeyToRevoke) {
            navigate(`/incluir/${cleanFile(fileKeyToRevoke)}`);
        }
        setOpenDialog(false);
    };

    const handleTotalRevoke = () => {
        setOpenDialog(false);
        setOpenSecondDialog(true);
    };

    const redirectToHTMLViewer = (fileKey: string) => {
        const url = `${PATH.baseApi}/render-html/?file_key=${cleanFile(fileKey)}`;
        window.open(url, '_blank');
    };

    const filteredFiles: File[] = Array.isArray(listPosts.data)
        ? listPosts.data
            .filter((file: File) => {
                return file.file_name.replace("/", "") !== fileKeyName;
            })
            .map((file: File) => {
                return {
                    id: file.id,
                    file_name: file.file_name,
                    checked: Array.isArray(selectedFiles) && selectedFiles.includes(file.file_name),
                };
            })
        : [];

    const cleanFile = (file: string) =>{
        const fileCleaned = file.replace("posts/", "");
        return fileCleaned;
    }

    useEffect(() => {
        const handleResize = () => {
            setIsResponsive(window.innerWidth <= 900);
        };

        window.addEventListener("resize", handleResize);
        handleResize();

        const liElements = document.querySelectorAll(
            "li[class*='rc-pagination-item']"
        );

        liElements.forEach((li) => {
            li.setAttribute("title", "");
        });

        const prevElement = document.querySelector("li.rc-pagination-prev");
        const nextElement = document.querySelector("li.rc-pagination-next");

        if (prevElement) {
            prevElement.setAttribute("title", "");
        }

        if (nextElement) {
            nextElement.setAttribute("title", "");
        }

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handlePageChange = (page: number) => {
        setPage(page);
    };

    const customItemRender = (current: number, type: string) => {
        if (type === "page") {
            return (
                current === currentPage && (
                    <span className={styles.currentPage}>
                        {data?.length > 0 ? page : "0"}
                    </span>
                )
            );
        }
        if (type === "prev") {
            return (
                <Button className={styles.backButton} title="Voltar">
                    Anterior
                </Button>
            );
        }
        if (type === "next") {
            return (
                <Button className={styles.backButton} title="Avançar">
                    Próxima
                </Button>
            );
        }
        return null;
    };

    const isFileFavorite = (fileKey: string) => {
        const cleanedFile = cleanFile(fileKey);
        return posts.some((fav: any) => {
            const fileFromUrl = fav.url?.split("file_key=")[1];
            return fileFromUrl === cleanedFile;
        });
    };

    const handlePinClick = (fileKey: string) => {
        setFileName(cleanFile(fileKey));
        if (!isFileFavorite(fileKey)) {
            handleCreateDialogDescription();
        }else{
            handleFavoritePost();
        }
    };    

    return (
        <div className={styles.content}>
            <div className={styles.header}>
                {title && <div className={styles.headerTable}>{title}</div>}
                {downloadButton && (
                <Button
                    className={styles.downloadButton}
                    onClick={handleDownloadTemplate}
                    alt="Baixar template"
                >
                    <MdOutlineFileDownload size={isResponsive ? 18 : 24} />
                </Button>
                )}
            </div>
            <div className={`${isLoggedIn() ? styles.containerLoggedIn : styles.container}`}>
                <div className={styles.tableHeader}>
                    {columns.map((column: any, index: any) => (
                        <div key={index} className={`${styles.columnHeader} ${styles[column.property]}`}>
                            {isResponsive && (column.property ==="date" || column.property === "status") ? (
                                column.property === "date" ? (
                                    <div className={styles.columnTitle}>
                                        Data / Status <MdKeyboardArrowDown
                                        size={16}
                                        onClick={handleSortClick}
                                        style={{
                                            transform: sortDirection === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)',
                                            transition: 'transform 0.3s ease',
                                            cursor: "pointer"
                                        }}
                                    />
                                    </div>
                                ) : null
                            ) : (
                                <div className={`${styles.columnTitle} ${styles[column.property]}`}>
                                    {column.property === "date" ? (
                                        <>
                                            {column.title} <MdKeyboardArrowDown
                                            size={16}
                                            onClick={handleSortClick}
                                            style={{
                                                transform: sortDirection === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)',
                                                transition: 'transform 0.3s ease',
                                                cursor: "pointer"
                                            }}
                                        />
                                        </>
                                    ) : (
                                        column.title
                                    )}
                                </div>
                            )}
                        </div>
                    ))}
                    </div>
                    <div className={styles.tableWrapper}>
                        <div className={styles.tableBody}>
                        {loading ? (
                            <div style={{ marginBottom: "3rem" }}>
                                <Loading size="5rem" type="spin" />
                            </div>
                        ) : (
                        <>
                            {isEmpty || error ? (
                            <div className={styles.empty}>
                                {isEmpty
                                ? "Não foi encontrado nenhum conteúdo"
                                : "Não foi possível carregar as informações!"}
                            </div>
                            ) : (
                            <>
                                {data?.map((row: any, rowIndex: any) => (
                                    <>
                                        <div key={rowIndex} data-action={row.action} className={`${styles.tableRow} ${styles[row.action?.replace(/\s+/g, '').toLowerCase()]}`}>
                                            {columns.map((column: any, columnIndex: any) => (
                                                <div key={columnIndex}
                                                     className={`${styles.row} ${styles[column.property]}`}>
                                                    {isResponsive && (column.property === "date" || column.property === "status") ? (
                                                        column.property === "date" ? (
                                                            <div className={styles.dateStatusContainer}>
                                                                <div className={styles.date}>{row["date"]}</div>
                                                                <div className={styles.status}>{row["status"]}</div>
                                                            </div>
                                                        ) : null
                                                    ) : column.property === "presigned_url" ? (
                                                        <button
                                                            onClick={() => handleDownloadFile(row[column.property])}
                                                            className={styles.button}
                                                            id="download"
                                                        >
                                                            <MdOutlineFileDownload size={isResponsive ? 18 : 24}/>
                                                        </button>
                                                    ) : column.property === "view" ? (
                                                        <div className={styles.tableCell}>
                                                            <button
                                                                id="view"
                                                                className={styles.button}
                                                                onClick={() => redirectToHTMLViewer(row["fileKey"])}
                                                            >
                                                                <MdSearch size={isResponsive ? 18 : 24}/>
                                                            </button>
                                                        </div>
                                                    ) : column.property === "pin" ? (
                                                        <div className={styles.tableCell}>
                                                            <button
                                                                id="pinButton"
                                                                className={`${isFileFavorite(row["fileKey"]) ? styles.favorited : styles.pinnedButton}`}
                                                                onClick={() => {
                                                                    handlePinClick(row["fileKey"]);
                                                                }}
                                                            >
                                                                <MdOutlinePushPin size={isResponsive ? 18 : 24}/>
                                                            </button>
                                                        </div>
                                                    ) : column.property === "revoke" ? (
                                                        <div className={styles.tableCell}>
                                                            <button
                                                                id="revokeIcon"
                                                                className={styles.button}
                                                                onClick={() => handleRevokeEdition(row["fileKey"])}
                                                                disabled={row.status === "Revogada"}
                                                            >
                                                                <MdOutlineEditNote size={isResponsive ? 18 : 24}/>
                                                            </button>
                                                        </div>
                                                    ) : column.property === "delete" ||
                                                    column.property === "deletePublished" ? (
                                                        <button
                                                            id="delete"
                                                            onClick={() => {
                                                                column.property === "delete"
                                                                    ? dispatch(fetchDeleteFile(row.delete))
                                                                    : handleDeletePublishedFileDialog(row);
                                                            }}
                                                            className={`${styles.button} ${deletingId === row.edition ? styles.spinning : ""}`}
                                                        >
                                                            <MdOutlineDelete size={isResponsive ? 18 : 24}/>
                                                        </button>
                                                    ) : (
                                                        <div
                                                            className={`${styles.tableCell} ${styles[column.property]}`}>
                                                            {column.property === "action" ? row.action : row[column.property]}
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                ))}
                            </>
                            )}
                        </>
                        )}
                </div>
            </div>
            </div>
            <div className={styles.pagination}>
                <Pagination
                    current={page}
                    onChange={handlePageChange}
                    total={total}
                    pageSize={25}
                    className={styles.customPagination}
                    itemRender={customItemRender}
                />
            </div>
                <Dialog  open={openDialogDescription} onClose={handleDialogDescriptionClose}>
                    <div id="pinDescription">
                    <DialogTitle >Adicione a descrição</DialogTitle>
                        <DialogContent>
                            <TextField 
                            id="descriptionText"
                            type="text" 
                            multiline={true} 
                            value={description} 
                            fullWidth={true}
                            onChange={(e) => setDescription(e.target.value)} 
                            placeholder="Escreva aqui"
                            inputProps={{ maxLength: 200 }}/>

                            {caracterLimit && <p>{message}</p>}
                            {!caracterLimit && <p>{message}</p>}
                        </DialogContent>
                    <DialogContent className={`${styles.descriptionButtons}`}>
                        <Button id='cancelar' className={`${styles.cancelDescriptionButton}`} onClick={handleDialogDescriptionClose}>
                            Cancelar
                        </Button>
                        <Button className={`${styles.confirmButton}`} onClick={handleSubmitDescription}>
                            Salvar
                        </Button>
                    </DialogContent>
                        </div>
                </Dialog>
                <Dialog open={openDialogDelete} onClose={handleDialogDeleteClose}>
                    <div>
                        <DialogContent>
                            <DialogTitle>Você realmente deseja excluir este arquivo?</DialogTitle>
                        </DialogContent>
                        <DialogContent className={`${styles.descriptionButtons}`}>
                        <Button className={`${styles.confirmButton}`} onClick={handleDeletePublishedFile}>
                            Sim
                        </Button>
                        <Button id='cancelar' className={`${styles.cancelDescriptionButton}`} onClick={handleDialogDeleteClose}>
                            Não
                        </Button>
                    </DialogContent>
                    </div>
                </Dialog>
            <Dialog id="editionMenu" open={openDialog} onClose={handleDialogClose}>
                <DialogTitle>Escolha uma opção</DialogTitle>
                <DialogContent className={`${styles.buttons}`}>
                    <Button id="includeButton" className={`${styles.confirmButton}`} onClick={handleInclude}>
                        <MdOutlineFileOpen size={isResponsive ? 18 : 24}/>
                        Incluir
                    </Button>
                    <Button id="modifyButton" className={`${styles.confirmButton}`} onClick={handlePartialRevoke}>
                        <MdDriveFileRenameOutline size={isResponsive ? 18 : 24}/>
                        Modificar
                    </Button>
                    <Button id="revokeButton" className={`${styles.confirmButton}`} onClick={handleTotalRevoke}>
                        <MdOutlineSubtitlesOff size={isResponsive ? 18 : 24}/>
                        Revogar totalmente
                    </Button>
                </DialogContent>
                <DialogActions>
                    <Button id='closeEditMenu' className={`${styles.cancelButton}`} onClick={handleDialogClose}>
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openSecondDialog} onClose={() => setOpenSecondDialog(false)}>
                <DialogContent>
                    <Autocomplete
                        options={filteredFiles.map((file) => formatFileName(file.file_name))}
                        sx={{ width: 300 }}
                        onChange={(e: any, newValue: string | null) => {
                            const selectedFile = filteredFiles.find((file) => formatFileName(file.file_name) === newValue);
                            if (selectedFile) {
                                setSelectedFiles((prevSelectedFiles) => {
                                    if (!prevSelectedFiles.includes(selectedFile.file_name)) {
                                        return [...prevSelectedFiles, selectedFile.file_name];
                                    }
                                    return prevSelectedFiles;
                                });
                            }
                        }}
                        noOptionsText="Nenhum Ato encontrado"
                        renderInput={(params) => <TextField {...params} label="Escolha o ato responsável" />}
                        getOptionLabel={(fileName: string) => fileName}
                    />
                </DialogContent>
                <DialogActions>
                    <Button className={`${styles.cancelButton}`} onClick={() => setOpenSecondDialog(false)}>
                        Cancelar
                    </Button>
                    <Button
                        className={`${styles.confirmButtonRevoke}`}
                        onClick={() => {
                            const data = {
                                file_name: fileKeyName,
                                edition: selectedFiles[0],
                                status: "Revogada"
                            };
                            dispatch(updatePost(data));
                            setOpenSecondDialog(false);
                        }}
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default Table;